import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { uncountableNounsData, getDataForDifficulty } from '../courses/data/vocabulary/uncountableNouns';

export default function UncountableNounsTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : uncountableNounsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
